// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    GatewayError,
    IIsPatientRegisteredRequestModel,
    IPatientRegistrationRequestModel,
    PatientAccountGetCaseGetCaseRequestModel,
    PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse,
    PatientAccountPatientAccountGetCaseDefaultResponse,
    PatientAccountPatientAccountPatientRegistrationDefaultResponse,
    PatientAccountPatientAccountUpdatePatientDemographicsDefaultResponse,
    UpdatePatientDemographicsRequest,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePatientAccountApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param patientAccountGetCaseGetCaseRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientAccountGetCase (patientAccountGetCaseGetCaseRequestModel: PatientAccountGetCaseGetCaseRequestModel, xProgramId?: string): Promise<AxiosResponse<PatientAccountPatientAccountGetCaseDefaultResponse>> {
        const _url_ = '/edge/patientAccount/GetCase';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientAccountGetCaseGetCaseRequestModel' is not null or undefined
        if (patientAccountGetCaseGetCaseRequestModel === null || patientAccountGetCaseGetCaseRequestModel === undefined) {
            throw new Error('Required parameter patientAccountGetCaseGetCaseRequestModel was null or undefined when calling patientAccountGetCase.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientAccountGetCaseGetCaseRequestModel, "PatientAccountGetCaseGetCaseRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientAccountPatientAccountGetCaseDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountPatientAccountGetCaseDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param iIsPatientRegisteredRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientAccountIsPatientRegistered (iIsPatientRegisteredRequestModel: IIsPatientRegisteredRequestModel, xProgramId?: string): Promise<AxiosResponse<PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse>> {
        const _url_ = '/edge/patientAccount/IsPatientRegistered';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iIsPatientRegisteredRequestModel' is not null or undefined
        if (iIsPatientRegisteredRequestModel === null || iIsPatientRegisteredRequestModel === undefined) {
            throw new Error('Required parameter iIsPatientRegisteredRequestModel was null or undefined when calling patientAccountIsPatientRegistered.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iIsPatientRegisteredRequestModel, "IIsPatientRegisteredRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountIsPatientRegisteredPatientAccountIsPatientRegisteredDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param iPatientRegistrationRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientAccountPatientRegistration (iPatientRegistrationRequestModel: IPatientRegistrationRequestModel, xProgramId?: string): Promise<AxiosResponse<PatientAccountPatientAccountPatientRegistrationDefaultResponse>> {
        const _url_ = '/edge/patientAccount/PatientRegistration';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'iPatientRegistrationRequestModel' is not null or undefined
        if (iPatientRegistrationRequestModel === null || iPatientRegistrationRequestModel === undefined) {
            throw new Error('Required parameter iPatientRegistrationRequestModel was null or undefined when calling patientAccountPatientRegistration.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(iPatientRegistrationRequestModel, "IPatientRegistrationRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientAccountPatientAccountPatientRegistrationDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountPatientAccountPatientRegistrationDefaultResponse");
        }
        return response;
    }
    /**
     * 
     * @param updatePatientDemographicsRequest default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientAccountUpdatePatientDemographics (updatePatientDemographicsRequest: UpdatePatientDemographicsRequest, xProgramId?: string): Promise<AxiosResponse<PatientAccountPatientAccountUpdatePatientDemographicsDefaultResponse>> {
        const _url_ = '/edge/patientAccount/UpdatePatientDemographics';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'updatePatientDemographicsRequest' is not null or undefined
        if (updatePatientDemographicsRequest === null || updatePatientDemographicsRequest === undefined) {
            throw new Error('Required parameter updatePatientDemographicsRequest was null or undefined when calling patientAccountUpdatePatientDemographics.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(updatePatientDemographicsRequest, "UpdatePatientDemographicsRequest"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PatientAccountPatientAccountUpdatePatientDemographicsDefaultResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PatientAccountPatientAccountUpdatePatientDemographicsDefaultResponse");
        }
        return response;
    }
}
